var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c("PageHeader", { attrs: { title: "Guidelines", icon: "rule" } }),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Guidelines", search: "guidelines" },
          model: {
            value: _vm.searchText,
            callback: function ($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "info" },
              on: {
                click: function ($event) {
                  return _vm.allExpansionOpen()
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("zoom_in")]),
              _vm._v("\n      " + _vm._s(_vm.$t("Button.Expand")) + "\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { color: "info" },
              on: {
                click: function ($event) {
                  return _vm.allExpansionClose()
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("zoom_out")]),
              _vm._v("\n      " + _vm._s(_vm.$t("Button.Collapse")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.categorized, function (category, index) {
        return _c(
          "v-layout",
          { key: index },
          [
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-text",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.search === null || _vm.search === "",
                            expression: "search === null || search === ''",
                          },
                        ],
                        staticStyle: {
                          "padding-left": "24px",
                          "font-size": "18px",
                          "border-top": "1px solid rgba(0,0,0,.12)",
                          "border-left": "2px #E8E8E8",
                          "border-right": "2px \t#E8E8E8",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(category.acronym) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-expansion-panel",
                      {
                        attrs: { focusable: "", expand: "" },
                        model: {
                          value: category.panelArray,
                          callback: function ($$v) {
                            _vm.$set(category, "panelArray", $$v)
                          },
                          expression: "category.panelArray",
                        },
                      },
                      _vm._l(category.Guidelines, function (g) {
                        return _c(
                          "v-expansion-panel-content",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.search === null ||
                                  _vm.search === "" ||
                                  (_vm.search &&
                                    (_vm.showSection.indexOf(g.Id) >= 0 ||
                                      _vm.searchGroup(_vm.search, g))),
                                expression:
                                  "search === null || search === ''|| (search && (showSection.indexOf(g.Id) >= 0 || searchGroup(search, g)))",
                              },
                            ],
                            key: g.Id,
                            staticStyle: {
                              "border-top":
                                "1px solid rgba(0,0,0,.12) !important",
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "header" }, slot: "header" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-medium" },
                                  [
                                    _vm._v(
                                      _vm._s(g.GuidelineLongName) +
                                        " (" +
                                        _vm._s(g.GuidelineName) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-data-table", {
                              staticClass: "elevation-1",
                              attrs: {
                                headers: _vm.headers,
                                items: g.Standards,
                                search: _vm.search,
                                filter: (val, search) => {
                                  return (
                                    _vm.searchList(val, search, g.Id) ||
                                    _vm.searchGroup(search, g)
                                  )
                                },
                                "hide-actions": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "items",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item
                                                  .AnalyteNameInGuideline
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("td", {
                                          staticClass: "text-xs-left",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getGuidelineValue(props.item)
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.Unit))]
                                        ),
                                        _vm._v(" "),
                                        _vm.IsHtml(props.item.ReferenceSource)
                                          ? [
                                              _vm.linkTo(
                                                props.item.ReferenceSource
                                              )
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left",
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: _vm.linkTo(
                                                              props.item
                                                                .ReferenceSource
                                                            ),
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.item
                                                                .ReferenceSource
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c("td", {
                                                    staticClass: "text-xs-left",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        props.item
                                                          .ReferenceSource
                                                      ),
                                                    },
                                                  }),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.IsHtml(props.item.ReferenceSource)
                                          ? [
                                              _c("td", {
                                                staticClass: "text-xs-left",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.linkExtract(
                                                      props.item.ReferenceSource
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("td", {
                                          staticClass: "text-xs-left",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              props.item.LastModifiedDateTime !=
                                                null
                                                ? _vm.formatDate(
                                                    props.item
                                                      .LastModifiedDateTime,
                                                    _vm.prettyDateTimeFormat
                                                  )
                                                : ""
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("td", {
                                          staticClass: "text-xs-left",
                                          domProps: {
                                            innerHTML: _vm._s(props.item.Notes),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("td", {
                                          staticClass: "text-xs-left",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              props.item.LastModifiedBy
                                            ),
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }